import React from 'react';
import { TableColumnsType, Tag } from 'antd';
import { DataType } from '../interfaces/costcoDashboard.interface';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export interface VerificationTypeConfig {
    key: string;
    label: string;
    hasSystemPreferences: boolean;
    columns: TableColumnsType<DataType>;
}

const commonDateFormat = (value: number) => {
    if (!value) return 'NA';
    const estTimeZone = 'America/New_York';
    return `${dayjs.unix(value).tz(estTimeZone).format('MMM DD, YYYY HH:mm:ss')} EST`;
};

export const VERIFICATION_TYPES: Record<string, VerificationTypeConfig> = {
    COSTCO: {
        key: 'COSTCO',
        label: 'Costco',
        hasSystemPreferences: true,
        columns: [
            {
                title: 'Customer ID',
                dataIndex: 'customerId',
                width: '15%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Membership ID',
                dataIndex: 'membershipId',
                width: '15%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Email',
                dataIndex: 'customerEmail',
                width: '18%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                width: '22%',
                render: commonDateFormat,
            },
            {
                title: "Source",
                dataIndex: "source",
                width: '12%',
                render: (value: string) => value || 'NA',
            },
            {
                title: "Request By",
                dataIndex: "requestBy",
                width: '18%',
                render: (value: string) => value || 'NA',
            }
        ],
    },
    CAA: {
        key: 'CAA',
        label: 'CAA',
        hasSystemPreferences: true,
        columns: [
            {
                title: 'Customer ID',
                dataIndex: 'customerId',
                width: '20%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Membership Number',
                dataIndex: 'membershipId',
                width: '20%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                width: '25%',
                render: commonDateFormat,
            },
            {
                title: "Source",
                dataIndex: "source",
                width: '15%',
                render: (value: string) => value || 'NA',
            },
            {
                title: "Request By",
                dataIndex: "requestBy",
                width: '20%',
                render: (value: string) => value || 'NA',
            }
        ],
    },
    AAA: {
        key: 'AAA',
        label: 'AAA',
        hasSystemPreferences: true,
        columns: [
            {
                title: 'Customer ID',
                dataIndex: 'customerId',
                width: '20%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Membership Number',
                dataIndex: 'membershipId',
                width: '20%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                width: '25%',
                render: commonDateFormat,
            },
            {
                title: "Source",
                dataIndex: "source",
                width: '15%',
                render: (value: string) => value || 'NA',
            },
            {
                title: "Request By",
                dataIndex: "requestBy",
                width: '20%',
                render: (value: string) => value || 'NA',
            }
        ],
    },
    MILITARY: {
        key: 'MILITARY',
        label: 'Military',
        hasSystemPreferences: false,
        columns: [
            {
                title: 'Customer ID',
                dataIndex: 'customerId',
                width: '15%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Customer Email',
                dataIndex: 'customerEmail',
                width: '20%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Phone',
                dataIndex: 'customerPhone',
                width: '15%',
                render: (value: string) => value || 'NA',
            },
            {
                title: 'Status',
                dataIndex: 'status',
                width: '15%',
                render: (value: string) => (
                    <Tag color={value === 'VERIFIED' ? 'green' : value === 'FAILED' ? 'red' : 'orange'}>
                        {value || 'NA'}
                    </Tag>
                ),
            },
            {
                title: 'Verified Email',
                dataIndex: 'idpVerifiedEmail',
                width: '15%',
                render: (value: string) => (value && value !== 'NA') ? value : 'NA',
            },
            {
                title: 'Verified At',
                dataIndex: 'completedAt',
                width: '20%',
                render: (value: number) => value === 0 ? 'Pending' : commonDateFormat(value),
            },
        ],
    },
};
